














































import { reactive, computed, onBeforeMount, onMounted } from '@vue/composition-api';

import { Deck, EditCardPayload } from '@/types';
import store from '../store';
import router from '../router';

import CardEditor from '@/components/CardEditor.vue';
import DeckEditor from '@/components/DeckEditor.vue';
import DeckDisplay from '@/components/DeckDisplay.vue';
import NewCardButton from '@/components/NewCardButton.vue';
import NewDeckButton from '@/components/NewDeckButton.vue';

export default {
  name: 'ComposVuexPersist',
  components: { DeckDisplay, DeckEditor, CardEditor, NewCardButton, NewDeckButton },

  setup() {
    onMounted(() => {
      function startup(retry: number) {
        if (retry >= 2) router.push('/login/?checkauth=no');
        else if (
          store.state.authMod.jwt &&
          store.state.authMod.keyPair &&
          store.state.authMod.threadID
        )
          store.dispatch.authMod.initialize({
            jwt: store.state.authMod.jwt,
            keyPair: store.state.authMod.keyPair,
            threadID: store.state.authMod.threadID,
            retry: 0,
          });
        else {
          store.dispatch.authMod.rehydrateUser().then(() => {
            console.log('checking auth from home');
            store.dispatch.authMod.checkAuth().then(verified => {
              if (verified) startup(retry + 1);
              else router.push('/login/?checkauth=no');
            });
          });
        }
      }
      startup(0);
    });

    const decks = computed(() => {
      // console.log('decks changed');
      return store.getters.decksMod.decks.filter(deck => !deck.deleted);
    });

    const emptyPayload = {
      card: { _id: '', updatedAt: 0, frontText: '', backText: '' },
      deckId: '',
    };
    const state = reactive({
      selectedDeck: decks ? (decks.value[0] as Deck) : undefined,
      showCardEditor: false as boolean,
      showDeckEditor: false as boolean,
      editPayload: emptyPayload as EditCardPayload,
      newCard: false as boolean,
    });

    const createDeck = async function(deck: Deck) {
      await store.dispatch.decksMod.deckMergeToState({ decks: [deck], skipThreadMerge: false });
      state.selectedDeck = deck;
      state.showDeckEditor = false;
    };
    const deleteDeck = (deckId: string) => {
      store.dispatch.decksMod.deleteDeck(deckId);
    };
    const addNewCard = (payload: EditCardPayload) => {
      store.dispatch.decksMod.addCard(payload);
      state.showCardEditor = false;
      state.newCard = false;
    };
    const editCard = (payload: EditCardPayload) => {
      store.dispatch.decksMod.editCard(payload);
      state.showCardEditor = false;
      state.newCard = false;
    };
    const deleteCard = (payload: EditCardPayload) => {
      store.dispatch.decksMod.editCard(payload);
    };
    const changeSelectedDeck = (deckId: string) => {
      console.log('changeSelectedDeck', deckId);
      decks.value.forEach(deck => {
        if (deck._id === deckId) state.selectedDeck = deck;
      });
    };
    const openCardEditor = (payload: EditCardPayload) => {
      if (!state.newCard) state.editPayload = payload;
      else state.editPayload = emptyPayload;
      state.showCardEditor = true;
    };

    return {
      decks,
      state,
      createDeck,
      deleteDeck,
      addNewCard,
      emptyPayload,
      editCard,
      deleteCard,
      changeSelectedDeck,
      openCardEditor,
    };
  },
};
